import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import * as actions from "../../../store/actions";

import { useInfiniteScroll } from "../../../utils/pagination";
import BlockedList from "./BlockedList";
import "./index.css";

const BlockPatients = ({
  blockedPatients,
  allblockedPatients,
  total,
  emptyBlockedPatients,
  patientUnblock,
}) => {
  const [page, setPage] = useState(0);
  const bloader = useRef(null);

  useInfiniteScroll(bloader, () => {
    setPage(page => page + 1);
  });

  useEffect(() => {
    if (page > 0 && page <= total) {
      allblockedPatients(page);
    }
    // eslint-disable-next-line
  }, [page]);

  useEffect(() => {
    emptyBlockedPatients();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <p className="text-dark h5 mb-4">Blocked Patients</p>
      <p>
        Blocked patients are not allowed to connect you on the platform, in
        their searches they won't find your profile.
      </p>
      <BlockedList patients={blockedPatients} patientUnblock={patientUnblock} />
      <div ref={bloader}></div>
    </div>
  );
};

const mapStoreToProps = ({ settings }) => ({
  blockedPatients: settings?.blocked?.allBlocked,
  total: settings?.blocked?.total,
});

const mapDispatchToProps = dispatch => ({
  allblockedPatients: page => dispatch(actions.allblockedPatients(page)),
  emptyBlockedPatients: () => dispatch(actions.emptyBlockedPatients()),
  patientUnblock: id => dispatch(actions.patientUnblock(id)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(BlockPatients);
